import { render, staticRenderFns } from "./WatchSpot.vue?vue&type=template&id=d6516ff0&scoped=true"
import script from "./WatchSpot.vue?vue&type=script&lang=js"
export * from "./WatchSpot.vue?vue&type=script&lang=js"
import style0 from "./WatchSpot.vue?vue&type=style&index=0&id=d6516ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6516ff0",
  null
  
)

export default component.exports